<template>
  <div class="home">
    <Header style="height: 100vh; border: 1rem solid white;"></Header>

    <section id="main">
      <SectionIntro></SectionIntro>

      <SectionOverview></SectionOverview>

      <SectionOverallTrends></SectionOverallTrends>

      <nav id="pages">
        <div class="row clearfix">
          <router-link :to="{name:'States'}" class="next sixcol last">States →</router-link>
        </div>
      </nav>
    </section>
  </div>
</template>

<script>
import SectionIntro from './Overview/2019/Intro'
import SectionOverview from './Overview/2019/Overview'
import SectionOverallTrends from './Overview/2019/OverallTrends'

export default {
  name: 'Overview',
  components: {
    SectionIntro,
    SectionOverview,
    SectionOverallTrends
  },
  mounted () {
    window.scrollTo(0, 0)
  }
}
</script>
